import api from '@/api';

export default {
  namespaced: true,
  state     : {
    content: [],
    sizes  : [],
  },
  getters: {
    content: ({content}) => content,
    sizes  : ({sizes}) => sizes,
  },
  mutations: {
    SET_CONTENT(state, value) {
      state.content = value.data;
    },
    SET_SIZES(state, value) {
      const product_size = value.PRODUCTS.map((item) => {
        return {size: item.SIZE || item.EUSIZE, id: item.ID, REMAINDER: item.REMAINDER};
      });
      product_size.push({size: value.MAIN_PRODUCT.SIZE || value.MAIN_PRODUCT.EUSIZE, id: value.MAIN_PRODUCT.ID, REMAINDER: value.MAIN_PRODUCT.REMAINDER});
      product_size.sort((a, b) => {
        if (a.size > b.size) {
          return 1;
        }
        if (a.size < b.size) {
          return -1;
        }
        return 0;
      });
      state.sizes = product_size;
    },
  },
  actions: {
    async getDetail({commit}, id) {
      try {
        const get_catalog = await api.prize_shop.catalog_detail(id);
        commit('SET_CONTENT', get_catalog.data);
        commit('SET_SIZES', get_catalog.data.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
